import { RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';
import { SharedModule } from './features/shared/shared.module';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/dashboard/map'
  }
];

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forRoot(routes, {
      useHash: false,
      enableTracing: false,
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking'
    })
  ]
})
export class AppRoutingModule {}
